import React from 'react';

const MessageSkeleton = ({ count = 3 }) => {
  return (
    <div className="p-2">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className={`mb-3 ${index % 2 === 1 ? 'd-flex justify-content-end' : ''}`}>
          <div className="d-flex align-items-start">
            {/* Avatar skeleton */}
            <div className={`me-3 ${index % 2 === 1 ? 'order-2 ms-3 me-0' : ''}`}>
              <div className="bg-light rounded-circle" style={{ width: '40px', height: '40px' }}></div>
            </div>
            
            {/* Message content skeleton */}
            <div className={`flex-grow-1 ${index % 2 === 1 ? 'order-1' : ''}`}>
              {/* Message bubble skeleton */}
              <div className={`bg-light rounded p-2 mb-2 ${index % 2 === 1 ? 'bg-primary bg-opacity-10' : ''}`} style={{ maxWidth: '70%' }}>
                <div className="bg-secondary bg-opacity-25 rounded mb-1" style={{ height: '12px', width: '60%' }}></div>
                <div className="bg-secondary bg-opacity-25 rounded mb-1" style={{ height: '12px', width: '80%' }}></div>
                <div className="bg-secondary bg-opacity-25 rounded" style={{ height: '12px', width: '100%' }}></div>
              </div>
              
              {/* Time skeleton */}
              <div className="bg-secondary bg-opacity-25 rounded" style={{ width: '50px', height: '10px' }}></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MessageSkeleton;
